import {
    FETCH_NOTIFICATION_DATA_REQUEST,
    FETCH_FILTER_NOTIFICATION_DATA_REQUEST,
    UPDATE_NOTIFICATION_DATA_REQUEST,
    CHANGE_GROUP_UPDATES_REQUEST,
    FETCH_FILTER_GROUP_BY_DATA_REQUEST,
    CHANGE_ACTIVITY_UPDATES_REQUEST,
    FETCH_NOTIFICATION_DETAIL_DATA_REQUEST,
    RESET_NOTIFICATION_DETAIL,
    GET_AU_COUNT_REQUEST,
    NEW_NOTIFICATION_REQUEST,
    UPDATE_NOTIFICATION_COUNTER,
    RESET_NOTIFICATION_REQUEST,
    NOTIFICATION_SORTING_REQUEST,
    UPDATE_RECENT_NOTIFICATION_STATUS_REQUEST
} from './actionConstants';

export const fetchNotificationData = payload => ({
    type: FETCH_NOTIFICATION_DATA_REQUEST,
    payload
});

export const filterNotificationData = payload => ({
    type: FETCH_FILTER_NOTIFICATION_DATA_REQUEST,
    payload
});

export const updateNotificationData = payload => ({
    type: UPDATE_NOTIFICATION_DATA_REQUEST,
    payload
});

export const changeGroupUpdates = payload => ({
    type:CHANGE_GROUP_UPDATES_REQUEST,
    payload
})
export const filterGroupByData = payload => ({
    type: FETCH_FILTER_GROUP_BY_DATA_REQUEST,
    payload
});

export const changeActivityUpdatesStatus = payload => ({
    type:CHANGE_ACTIVITY_UPDATES_REQUEST,
    payload
})

export const fetchNotificationDetailData = payload => ({
    type:FETCH_NOTIFICATION_DETAIL_DATA_REQUEST,
    payload
});

export const resetNotificationDetail = payload => ({
    type:RESET_NOTIFICATION_DETAIL,
    payload
})

export const getAUCounts = payload =>({
    type:GET_AU_COUNT_REQUEST,
    payload
})

export const getNewNotificationCount = payload => ({
    type: NEW_NOTIFICATION_REQUEST,
    payload
})

export const updateNotificationCount = payload => ({
    type: UPDATE_NOTIFICATION_COUNTER,
    payload
})

export const resetNotification = payload => ({
    type: RESET_NOTIFICATION_REQUEST,
})

export const handleSorting = payload => ({
    type:NOTIFICATION_SORTING_REQUEST,
    payload
})

export const updateRecentWorkkardGroupNotificationStatus = payload => ({
    type: UPDATE_RECENT_NOTIFICATION_STATUS_REQUEST,
    payload
})